// packages/app/src/components/solutions-agent/PipelineSteps.tsx
import { makeStyles, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import ScheduleIcon from '@material-ui/icons/Schedule';
import {
  PIPELINE_STEPS,
  PipelineStepId,
  stepIndex,
} from './types';

const useStyles = makeStyles(theme => ({
  root: {
    width: 200,
    flexShrink: 0,
    borderRight: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),
    color: theme.palette.text.secondary,
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  done: {
    color: theme.palette.success.main,
  },
  meta: {
    marginTop: theme.spacing(2),
    fontSize: 12,
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
  },
}));

interface PipelineStepsProps {
  activeStep: PipelineStepId | null;
  status?: string;
  phase?: string;
  runId?: string | null;
}

export const PipelineSteps = ({
  activeStep,
  status,
  phase,
  runId,
}: PipelineStepsProps) => {
  const classes = useStyles();
  const activeIdx = stepIndex(activeStep);
  const isComplete = activeStep === 'complete';

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" className={classes.title}>
        Pipeline
      </Typography>
      {PIPELINE_STEPS.map((step, idx) => {
        const done = isComplete || (activeIdx >= 0 && idx < activeIdx);
        const active = !isComplete && idx === activeIdx;
        return (
          <div
            key={step.id}
            className={`${classes.step} ${done ? classes.done : ''} ${
              active ? classes.active : ''
            }`}
          >
            {done ? (
              <CheckCircleIcon fontSize="small" />
            ) : active ? (
              <ScheduleIcon fontSize="small" />
            ) : (
              <RadioButtonUncheckedIcon fontSize="small" />
            )}
            <span>{step.label}</span>
          </div>
        );
      })}
      <div className={classes.meta}>
        {status && <div>status: {status}</div>}
        {phase && <div>phase: {phase}</div>}
        {runId && <div>runId: {runId}</div>}
      </div>
    </div>
  );
};

export default PipelineSteps;
